import {
  two_factor_activation_panel_default
} from "./chunk-UK5OXW5V.mjs";
import {
  two_factor_disabled_panel_default
} from "./chunk-SKSEIY7P.mjs";
import {
  WithTwofactorRender
} from "./chunk-XKYH32TC.mjs";
import {
  TotpPanelContent
} from "./chunk-VMSVOVYF.mjs";
import {
  TOTPRiskPanel
} from "./chunk-E4S5BQNH.mjs";
import {
  LanguageSwitch
} from "./chunk-GQAGMJ4X.mjs";
import {
  getReferralProgramSidePanel
} from "./chunk-CRGWXVYX.mjs";
import {
  WithReferralRender
} from "./chunk-CI2MJ5LN.mjs";
import {
  help_center_header_button_default
} from "./chunk-HPDODORH.mjs";
import {
  AccountSwitch
} from "./chunk-PTZP5FSJ.mjs";
import {
  header_button_default
} from "./chunk-QMLW6FHI.mjs";
import {
  HeaderElement
} from "./chunk-WVTBFX6N.mjs";
import {
  HeaderWider
} from "./chunk-BCKBC2DN.mjs";
import {
  Header
} from "./chunk-RTNNUDKV.mjs";
import {
  ChangePasswordPanel
} from "./chunk-XHWEBRXA.mjs";
import {
  create_account_panel_default
} from "./chunk-RAYBOIPJ.mjs";
import {
  TWO_FACTOR_TOTP_FORM_ID
} from "./chunk-Y6C2WA2G.mjs";
import {
  SidePanelHeader
} from "./chunk-A2UNT4DX.mjs";
import {
  useLayoutContext
} from "./chunk-HFINPXUM.mjs";
import {
  useSmallScreen
} from "./chunk-ALXBK6NV.mjs";

// src/internal/components/totp-panel/totp-panel-footer.tsx
import { useCallback as useCallback3, useMemo } from "react";
import { useAuthContext as useAuthContext4 } from "@clara/auth";
import { useT as useT5 } from "@clara/locale";
import { Button as Button3, useSnackbar as useSnackbar4 } from "@clara/ui";
import { isEmpty } from "@clara/utils";

// src/header.tsx
import * as React4 from "react";
import { HelpHeadsetIcon, PersonIcon as PersonIcon2 } from "@clara/icons";
import { useT as useT4 } from "@clara/locale";
import { callAllHandlers } from "@clara/utils";
import { ZendeskButton as ZendeskButton2 } from "@clara/zendesk";

// src/internal/components/user-profile-panel/user-profile-panel.tsx
import * as React3 from "react";
import {
  SupportAgent as SupportAgentIcon,
  CheckCircle as CheckCircleIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon
} from "@mui/icons-material";
import { List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import Divider from "@mui/material/Divider";
import Stack3 from "@mui/material/Stack";
import Typography3 from "@mui/material/Typography";
import { useAuthContext as useAuthContext3, useMultientityContext } from "@clara/auth";
import {
  EmailIcon,
  PersonIcon,
  ChevronRightIcon,
  PasswordIcon,
  SecurityIcon,
  LogoutIcon,
  ReferralsIcon
} from "@clara/icons";
import { useT as useT3 } from "@clara/locale";
import { useSnackbar as useSnackbar3, Button as Button2 } from "@clara/ui";
import { ZendeskButton } from "@clara/zendesk";

// src/internal/components/edit-phone-form/edit-phone-form.tsx
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import { object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormControl, FormHelperText, Stack, Typography } from "@mui/material";
import { SIFT_ACTION_PHONE_EDIT, useAuthContext } from "@clara/auth";
import { useBoolean } from "@clara/hooks";
import { PhoneIcon, EditIcon } from "@clara/icons";
import { useT } from "@clara/locale";
import {
  COUNTRIES,
  isPhoneNumberValid,
  PhoneInput,
  useSnackbar,
  IconButton
} from "@clara/ui";
import { pick } from "@clara/utils";

// src/internal/components/totp-panel/totp-panel.tsx
import { jsx } from "react/jsx-runtime";
var TOTPPanel = ({
  onContinue,
  actionType,
  action
}) => {
  return [
    {
      children: [
        {
          element: /* @__PURE__ */ jsx(TotpPanelContent, {}),
          header: /* @__PURE__ */ jsx(SidePanelHeader, { variant: "alternate", headline: "" }),
          footer: /* @__PURE__ */ jsx(
            TotpPanelFooter,
            {
              onContinue,
              actionType,
              action
            }
          )
        }
      ]
    }
  ];
};

// src/internal/components/edit-phone-form/edit-phone-form.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var ProfileFormSchema = object().shape({
  mobilePhone: string().required("yup.errors.required").test("mobilePhone", "field.phone.error", (value, { parent }) => {
    return !!value && isPhoneNumberValid(parent.lada + value);
  }),
  lada: string().required("yup.errors.required"),
  country: object().required("yup.errors.required")
});
var PROFILE_FORM_ID = "profile-form";
var EditPhoneForm = () => {
  var _a, _b, _c;
  const { t } = useT(["common", "auth"]);
  const {
    user,
    setPanelFormData,
    updateMobilePhone,
    fetchUser,
    totp: { fetchCodes, setTotpError }
  } = useAuthContext();
  const { sidePanel, referralProgram } = useLayoutContext();
  const form = useForm({
    resolver: yupResolver(ProfileFormSchema),
    defaultValues: {
      mobilePhone: (_a = user == null ? void 0 : user.contactInfo) == null ? void 0 : _a.mobilePhone,
      lada: (_b = user == null ? void 0 : user.contactInfo) == null ? void 0 : _b.lada,
      country: {}
    },
    mode: "onChange"
  });
  const snackbar = useSnackbar();
  const [canEditPhone, { toggle }] = useBoolean();
  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { isValid },
    trigger,
    reset
  } = form;
  const country = watch("country");
  const handleEditPhone = React.useCallback(() => {
    toggle();
    if (user && "contactInfo" in user) {
      const country2 = COUNTRIES[user.contactInfo.isoCode];
      reset({
        mobilePhone: user.contactInfo.mobilePhone,
        lada: user.contactInfo.lada,
        country: country2
      });
    }
    trigger();
  }, [toggle, trigger, user, reset]);
  React.useEffect(() => {
    setPanelFormData({
      formId: PROFILE_FORM_ID,
      payload: {
        editPhone: canEditPhone,
        isValid,
        handelCancel: () => {
          handleEditPhone();
        }
      }
    });
  }, [canEditPhone, handleEditPhone, setPanelFormData, isValid]);
  React.useEffect(() => {
    if (user && "contactInfo" in user) {
      const country2 = COUNTRIES[user.contactInfo.isoCode];
      reset({
        mobilePhone: user.contactInfo.mobilePhone,
        lada: user.contactInfo.lada,
        country: country2
      });
    }
  }, [reset, user]);
  const showSnackBar = React.useCallback(
    (message, status) => {
      snackbar({
        message,
        status,
        position: "bottom-left",
        duration: 5e3
      });
    },
    [snackbar]
  );
  const handleEditoPhone = React.useCallback(
    async (formValues) => {
      await updateMobilePhone(formValues).then(async () => {
        await fetchUser(user == null ? void 0 : user.uuid);
        showSnackBar(t("update.mobilePhone.success"), "success");
        handleEditPhone();
        sidePanel.onOpen(user_profile_panel_default(referralProgram), 0);
      }).catch((error) => {
        if (error.response.status === 401 && // -1 when the user set the wrong totp code
        error.response.data.token === -1) {
          setTotpError("invalid-code");
        } else if (error.response.status === 401 && // -4 when the TOTP code is expired
        // -2 when the user enter more then 4 times the wrong totp code
        (error.response.data.token === -4 || error.response.data.token === -2)) {
          setTotpError("expired-code");
        }
      });
    },
    [
      fetchUser,
      handleEditPhone,
      referralProgram,
      setTotpError,
      showSnackBar,
      sidePanel,
      t,
      updateMobilePhone,
      user == null ? void 0 : user.uuid
    ]
  );
  const onSubmit = React.useCallback(
    async (formValues) => {
      fetchCodes(t("totp.action.phone", { ns: "auth" }), SIFT_ACTION_PHONE_EDIT).then(({ code, token }) => {
        if (!!code && !!token) {
          handleEditoPhone({ code, token, ...formValues });
        } else if (!code && !!token) {
          sidePanel.onOpen(
            [
              ...sidePanel.panels,
              ...TOTPPanel({
                action: t("totp.action.phone", { ns: "auth" }),
                actionType: SIFT_ACTION_PHONE_EDIT,
                onContinue: ({ code: code2, token: token2 }) => {
                  handleEditoPhone({ code: code2, token: token2, ...formValues });
                }
              })
            ],
            1
          );
          showSnackBar(
            t("totp.generateCode.success", { ns: "auth" }),
            "success"
          );
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          sidePanel.onOpen(TOTPRiskPanel, 0);
        } else {
          showSnackBar(t("totp.generate.code.error", { ns: "auth" }), "error");
        }
      });
    },
    [fetchCodes, handleEditoPhone, showSnackBar, sidePanel, t]
  );
  const phoneNumber = Object.values(
    pick((_c = user == null ? void 0 : user.contactInfo) != null ? _c : {}, ["lada", "mobilePhone"])
  ).join("");
  return /* @__PURE__ */ jsx2(Stack, { direction: "column", mb: 1, children: canEditPhone ? /* @__PURE__ */ jsx2(
    Stack,
    {
      id: PROFILE_FORM_ID,
      component: "form",
      onSubmit: handleSubmit(onSubmit),
      children: /* @__PURE__ */ jsx2(
        Controller,
        {
          control,
          name: "mobilePhone",
          render: ({ field, fieldState: { error } }) => /* @__PURE__ */ jsxs(FormControl, { error: !!error, children: [
            /* @__PURE__ */ jsx2(
              PhoneInput,
              {
                "data-testid": "new-user-mobile-phone",
                error: !!error,
                onTextChange: (e) => {
                  setValue("mobilePhone", e.target.value);
                  field.onChange(e.target.value);
                },
                label: t("field.phone.label"),
                text: field.value,
                country,
                onCountryChange: (option) => {
                  if (!!option) {
                    setValue("lada", option.dialCode);
                    setValue("country", COUNTRIES[option.id]);
                  }
                  trigger();
                }
              }
            ),
            !!error && /* @__PURE__ */ jsx2(FormHelperText, { children: t(error.message) })
          ] })
        }
      )
    }
  ) : /* @__PURE__ */ jsxs(Stack, { direction: "row", spacing: 20, children: [
    /* @__PURE__ */ jsxs(
      Stack,
      {
        "data-testid": "user-phone",
        direction: "row",
        alignItems: "center",
        flex: 1,
        spacing: 1,
        children: [
          /* @__PURE__ */ jsx2(PhoneIcon, { fontSize: "large" }),
          /* @__PURE__ */ jsx2(Typography, { variant: "body1", children: phoneNumber })
        ]
      }
    ),
    /* @__PURE__ */ jsx2(Stack, { children: /* @__PURE__ */ jsx2(
      IconButton,
      {
        type: "button",
        "aria-label": "Edit phone",
        variant: "alternative",
        children: /* @__PURE__ */ jsx2(
          EditIcon,
          {
            fontSize: "medium",
            onClick: () => {
              handleEditPhone();
            }
          }
        )
      }
    ) })
  ] }) });
};

// src/internal/components/two-factor-panel/two-factor-disabled-panel-v3.tsx
import * as React2 from "react";
import Stack2 from "@mui/material/Stack";
import Typography2 from "@mui/material/Typography";
import { SIFT_ACTION_MFA_RESET, useAuthContext as useAuthContext2 } from "@clara/auth";
import { Translation, useT as useT2 } from "@clara/locale";
import { Banner, Button, useSnackbar as useSnackbar2 } from "@clara/ui";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
function SidePanel() {
  const { t } = useT2(["auth", "common"]);
  const { twoFactorAuthentication: twofactor, setPanelFormData } = useAuthContext2();
  React2.useEffect(() => {
    setPanelFormData({
      formId: TWO_FACTOR_TOTP_FORM_ID
    });
  }, []);
  return /* @__PURE__ */ jsxs2(Stack2, { spacing: 3, width: "100%", children: [
    /* @__PURE__ */ jsxs2(Stack2, { spacing: 1, children: [
      /* @__PURE__ */ jsx3(Typography2, { variant: "body1", sx: { fontWeight: 600 }, children: t("reset.MFA.title.1") }),
      /* @__PURE__ */ jsx3(Typography2, { children: t("reset.MFA.title.1.description") })
    ] }),
    /* @__PURE__ */ jsxs2(Stack2, { children: [
      /* @__PURE__ */ jsx3(Typography2, { variant: "body1", sx: { fontWeight: 600 }, children: t("reset.MFA.title.2") }),
      /* @__PURE__ */ jsx3(Typography2, { children: t("reset.MFA.title.2.description") })
    ] }),
    twofactor.resetting.error && /* @__PURE__ */ jsx3(Banner, { status: "critical", children: t("error.message.support", { ns: "common" }) })
  ] });
}
var TwoFaDisablePanelFooter = () => {
  const {
    panelFormData,
    resetTwoFactor,
    twoFactorAuthentication: twofactor,
    totp: {
      fetchCodes,
      setTotpError,
      codes: { loading }
    }
  } = useAuthContext2();
  const snackbar = useSnackbar2();
  const { sidePanel } = useLayoutContext();
  const { t } = useT2("auth");
  const showSnackBar = React2.useCallback(
    (message, status) => {
      snackbar({
        message,
        status,
        position: "bottom-left",
        duration: 5e3
      });
    },
    [snackbar]
  );
  const handleOnSubmit = React2.useCallback(() => {
    fetchCodes(t("totp.action.MFA"), SIFT_ACTION_MFA_RESET).then(({ code, token }) => {
      if (!!code && !!token) {
        resetTwoFactor({ code, token });
      } else if (!code && !!token) {
        sidePanel.onOpen(
          [
            ...sidePanel.panels,
            ...TOTPPanel({
              action: t("totp.action.MFA"),
              actionType: SIFT_ACTION_MFA_RESET,
              onContinue: ({ code: code2, token: token2 }) => {
                resetTwoFactor({ code: code2, token: token2 }).catch((error) => {
                  if (error.response.status === 401 && // -1 when the user set the wrong totp code
                  error.response.data.token === -1) {
                    setTotpError("invalid-code");
                  } else if (error.response.status === 401 && // -4 when the TOTP code is expired
                  // -2 when the user enter more then 4 times the wrong totp code
                  (error.response.data.token === -4 || error.response.data.token === -2)) {
                    setTotpError("expired-code");
                  }
                });
              }
            })
          ],
          2
        );
        showSnackBar(t("totp.generateCode.success"), "success");
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sidePanel.onOpen(TOTPRiskPanel, 0);
      } else {
        showSnackBar(t("totp.generateCode.error", { ns: "auth" }), "error");
      }
    });
  }, [fetchCodes, resetTwoFactor, sidePanel, showSnackBar, t]);
  return /* @__PURE__ */ jsx3(
    Button,
    {
      type: "button",
      form: panelFormData == null ? void 0 : panelFormData.formId,
      isLoading: twofactor.resetting.loading || loading,
      disabled: twofactor.resetting.loading || loading,
      onClick: () => {
        handleOnSubmit();
      },
      children: t("twofactor.reset.submit")
    }
  );
};
var TwofactorDisabledSidePanelV3 = [
  {
    children: [
      {
        element: /* @__PURE__ */ jsx3(SidePanel, {}),
        header: /* @__PURE__ */ jsx3(Translation, { ns: "auth", children: (t) => /* @__PURE__ */ jsx3(
          SidePanelHeader,
          {
            variant: "alternate",
            headline: t("twofa_rest_headline")
          }
        ) }),
        footer: /* @__PURE__ */ jsx3(TwoFaDisablePanelFooter, {})
      }
    ]
  }
];
var two_factor_disabled_panel_v3_default = TwofactorDisabledSidePanelV3;

// src/internal/components/user-profile-panel/user-profile-panel.tsx
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
function SidePanel2(props) {
  const { t } = useT3("common");
  const sm = useSmallScreen();
  const { user, is_candidate, config } = useAuthContext3();
  const { has_multientities } = useMultientityContext();
  const currentPanel = [{ children: [props.current] }];
  const renderReferralButton = (referral) => {
    if (!referral.widgetType)
      return null;
    return /* @__PURE__ */ jsxs3(Stack3, { direction: "column", children: [
      /* @__PURE__ */ jsx4(Typography3, { variant: "body1.bold", children: t("referrals.headline") }),
      /* @__PURE__ */ jsxs3(
        ListItemButton,
        {
          "data-testid": "change-password",
          onClick: () => {
            var _a;
            return (_a = props.onOpen) == null ? void 0 : _a.call(
              props,
              currentPanel.concat(
                getReferralProgramSidePanel(props == null ? void 0 : props.referralProgram)
              ),
              1
            );
          },
          children: [
            /* @__PURE__ */ jsx4(ListItemIcon, { children: /* @__PURE__ */ jsx4(ReferralsIcon, { fontSize: "large", sx: { mr: 2 }, color: "secondary" }) }),
            /* @__PURE__ */ jsx4(
              ListItemText,
              {
                primary: t("referrals.action"),
                secondary: t("referrals.action")
              }
            ),
            renderRightIcon() && /* @__PURE__ */ jsx4(ListItemIcon, { children: /* @__PURE__ */ jsx4(
              ChevronRightIcon,
              {
                fontSize: "large",
                sx: {
                  color: "v3.content.low_emphasis"
                }
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ jsx4(Divider, {})
    ] });
  };
  const renderRightIcon = (isActive) => {
    return /* @__PURE__ */ jsxs3(Stack3, { direction: "row", alignItems: "center", spacing: 1, children: [
      !!isActive && /* @__PURE__ */ jsxs3(Stack3, { direction: "row", alignItems: "center", spacing: 1, children: [
        /* @__PURE__ */ jsx4(Typography3, { color: "secondary.main", children: t("active") }),
        /* @__PURE__ */ jsx4(CheckCircleIcon, { color: "success", sx: { fontSize: 20 } })
      ] }),
      /* @__PURE__ */ jsx4(KeyboardArrowRightIcon, {})
    ] });
  };
  const render2FAButton = (twofactor) => {
    let panel = currentPanel;
    if (config.version === "v3") {
      panel = currentPanel.concat(two_factor_disabled_panel_v3_default);
    } else {
      const isActive = !!(twofactor.status === "enabled");
      panel = currentPanel.concat(
        isActive ? two_factor_disabled_panel_default : two_factor_activation_panel_default
      );
    }
    return /* @__PURE__ */ jsxs3(Fragment2, { children: [
      /* @__PURE__ */ jsxs3(
        ListItemButton,
        {
          "data-testid": "2step-auth",
          onClick: () => {
            var _a;
            return (_a = props.onOpen) == null ? void 0 : _a.call(props, panel, 1);
          },
          children: [
            /* @__PURE__ */ jsx4(ListItemIcon, { children: /* @__PURE__ */ jsx4(SecurityIcon, { fontSize: "large", sx: { mr: 2 } }) }),
            /* @__PURE__ */ jsx4(
              ListItemText,
              {
                primary: t("profile.action.twofactor"),
                secondary: t("profile.action.twofactor")
              }
            ),
            renderRightIcon(true) && /* @__PURE__ */ jsx4(ListItemIcon, { children: /* @__PURE__ */ jsx4(
              ChevronRightIcon,
              {
                fontSize: "large",
                sx: {
                  color: "v3.content.low_emphasis"
                }
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ jsx4(Divider, {})
    ] });
  };
  return /* @__PURE__ */ jsx4(Stack3, { justifyContent: "space-between", flex: 1, children: /* @__PURE__ */ jsxs3(Stack3, { direction: "column", spacing: 4, maxWidth: "100%", children: [
    sm && has_multientities && /* @__PURE__ */ jsx4(React3.Fragment, { children: /* @__PURE__ */ jsx4(
      AccountSwitch,
      {
        onCreateAccount: () => {
          var _a;
          return (_a = props.onOpen) == null ? void 0 : _a.call(props, currentPanel.concat(create_account_panel_default));
        },
        children: /* @__PURE__ */ jsx4(
          Typography3,
          {
            "data-testid": "account-switch",
            variant: "body1",
            fontWeight: "600",
            children: t("accountSwitch.label", { ns: "common" })
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsxs3(Stack3, { direction: "column", spacing: 4, children: [
      /* @__PURE__ */ jsxs3(Stack3, { spacing: 2, children: [
        /* @__PURE__ */ jsx4(Typography3, { variant: "body1.bold", children: t("profile.user.actions") }),
        /* @__PURE__ */ jsxs3(Stack3, { direction: "row", spacing: 1, alignItems: "center", children: [
          /* @__PURE__ */ jsx4(PersonIcon, { fontSize: "large" }),
          /* @__PURE__ */ jsx4(Typography3, { children: t(`role.${user == null ? void 0 : user.role.toLowerCase()}`) })
        ] }),
        /* @__PURE__ */ jsxs3(
          Stack3,
          {
            "data-testid": "user-email",
            direction: "row",
            spacing: 1,
            alignItems: "center",
            children: [
              /* @__PURE__ */ jsx4(EmailIcon, { fontSize: "large" }),
              /* @__PURE__ */ jsx4(Typography3, { children: user == null ? void 0 : user.email })
            ]
          }
        ),
        /* @__PURE__ */ jsx4(EditPhoneForm, {})
      ] }),
      !is_candidate && props.referralProgram && /* @__PURE__ */ jsx4(WithReferralRender, { ...props.referralProgram, children: (props2) => renderReferralButton(props2) }),
      /* @__PURE__ */ jsxs3(Stack3, { "data-testid": "user-actions", direction: "column", spacing: 2, children: [
        (!is_candidate || !(user == null ? void 0 : user.socialLogin)) && /* @__PURE__ */ jsxs3(Stack3, { children: [
          /* @__PURE__ */ jsx4(Typography3, { variant: "body1.bold", children: t("profile.user.actions") }),
          /* @__PURE__ */ jsxs3(List, { children: [
            /* @__PURE__ */ jsx4(WithTwofactorRender, { children: (twofactor) => !is_candidate ? render2FAButton(twofactor) : null }),
            !(user == null ? void 0 : user.socialLogin) && /* @__PURE__ */ jsxs3(
              ListItemButton,
              {
                "data-testid": "change-password",
                onClick: () => {
                  var _a;
                  return (_a = props.onOpen) == null ? void 0 : _a.call(
                    props,
                    currentPanel == null ? void 0 : currentPanel.concat(ChangePasswordPanel),
                    1
                  );
                },
                children: [
                  /* @__PURE__ */ jsx4(ListItemIcon, { children: /* @__PURE__ */ jsx4(
                    PasswordIcon,
                    {
                      fontSize: "large",
                      sx: { mr: 2 },
                      color: "secondary"
                    }
                  ) }),
                  /* @__PURE__ */ jsx4(
                    ListItemText,
                    {
                      primary: t("profile.action.changePassword"),
                      secondary: t("profile.action.changePassword")
                    }
                  ),
                  renderRightIcon() && /* @__PURE__ */ jsx4(ListItemIcon, { children: /* @__PURE__ */ jsx4(
                    ChevronRightIcon,
                    {
                      fontSize: "large",
                      sx: {
                        color: "v3.content.low_emphasis"
                      }
                    }
                  ) })
                ]
              }
            ),
            /* @__PURE__ */ jsx4(Divider, {})
          ] })
        ] }),
        sm && /* @__PURE__ */ jsx4(LanguageSwitch, {})
      ] })
    ] })
  ] }) });
}
var ProfilePanelHeader = () => {
  const { user } = useAuthContext3();
  return /* @__PURE__ */ jsx4(SidePanelHeader, { headline: user == null ? void 0 : user.name });
};
var ProfilePanelFooter = () => {
  var _a, _b;
  const {
    signOut,
    panelFormData,
    updatingMobile: { loading, error },
    totp: { codes }
  } = useAuthContext3();
  const sm = useSmallScreen();
  const { t } = useT3("common");
  const snackbar = useSnackbar3();
  React3.useEffect(() => {
    if (!!error) {
      snackbar({
        message: t("update.mobilePhone.error"),
        status: "error",
        position: "bottom-left",
        duration: 5e3
      });
    }
  }, [error, snackbar, t]);
  if ((_a = panelFormData.payload) == null ? void 0 : _a.editPhone)
    return /* @__PURE__ */ jsxs3(Stack3, { direction: "row", spacing: 2, flex: 1, children: [
      /* @__PURE__ */ jsx4(
        Button2,
        {
          "data-testid": "cancel-edit-phone",
          variant: "secondary",
          onClick: () => {
            var _a2;
            (_a2 = panelFormData.payload) == null ? void 0 : _a2.handelCancel();
          },
          isDisabled: loading || codes.loading,
          flex: 1,
          children: t("cancel")
        }
      ),
      /* @__PURE__ */ jsx4(
        Button2,
        {
          form: panelFormData == null ? void 0 : panelFormData.formId,
          type: "submit",
          "data-testid": "submit-edit-phone",
          variant: "primary",
          isLoading: loading || codes.loading,
          isDisabled: loading || !((_b = panelFormData.payload) == null ? void 0 : _b.isValid) || codes.loading,
          flex: 1,
          children: t("saveChanges")
        }
      )
    ] });
  return /* @__PURE__ */ jsxs3(Fragment2, { children: [
    sm && /* @__PURE__ */ jsx4(
      ZendeskButton,
      {
        title: t("help.buttonText"),
        leftIcon: /* @__PURE__ */ jsx4(SupportAgentIcon, {}),
        flex: 1
      }
    ),
    /* @__PURE__ */ jsx4(
      Button2,
      {
        "data-testid": "logout",
        variant: "secondary",
        onClick: signOut,
        leftIcon: /* @__PURE__ */ jsx4(LogoutIcon, {}),
        ...sm && {
          flex: 1
        },
        children: t("sidebar.signOut")
      }
    )
  ] });
};
var getUserProfilePanel = (program) => [
  {
    children: [
      {
        element: /* @__PURE__ */ jsx4(SidePanel2, { referralProgram: program }),
        header: /* @__PURE__ */ jsx4(ProfilePanelHeader, {}),
        footer: /* @__PURE__ */ jsx4(ProfilePanelFooter, {})
      }
    ]
  }
];
var user_profile_panel_default = getUserProfilePanel;

// src/header.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
function Header2(props) {
  const {
    variant = "customer",
    sidebar,
    sidePanel,
    referralProgram,
    hasMultientities
  } = useLayoutContext();
  const { t } = useT4("common");
  const onToggle = callAllHandlers(
    props == null ? void 0 : props.onToggle,
    sidebar.onToggle
  );
  return /* @__PURE__ */ jsxs4(
    Header,
    {
      variant,
      onToggle,
      hasMultientities,
      children: [
        props.children,
        /* @__PURE__ */ jsx5(HeaderElement, { variant: "account", children: /* @__PURE__ */ jsx5(
          AccountSwitch,
          {
            onCreateAccount: () => sidePanel.onOpen(create_account_panel_default)
          }
        ) }),
        /* @__PURE__ */ jsxs4(HeaderElement, { variant: "tools", spacing: 0.5, children: [
          !sidebar.sm && /* @__PURE__ */ jsxs4(React4.Fragment, { children: [
            /* @__PURE__ */ jsx5(LanguageSwitch, {}),
            /* @__PURE__ */ jsx5(help_center_header_button_default, {})
          ] }),
          /* @__PURE__ */ jsx5(
            header_button_default,
            {
              "data-testid": "header-profile",
              variant,
              leftIcon: /* @__PURE__ */ jsx5(PersonIcon2, {}),
              onClick: () => {
                sidePanel.onOpen(user_profile_panel_default(referralProgram));
              },
              children: t("profile.label")
            }
          )
        ] })
      ]
    }
  );
}
function HeaderWider2(props) {
  const { t } = useT4("common");
  return /* @__PURE__ */ jsxs4(HeaderWider, { onClose: props.onClose, children: [
    props.children,
    /* @__PURE__ */ jsx5(HeaderElement, { variant: "tools", spacing: 0.5, children: /* @__PURE__ */ jsx5(
      ZendeskButton2,
      {
        "data-testid": "header-help",
        render: (props2) => /* @__PURE__ */ jsx5(header_button_default, { leftIcon: /* @__PURE__ */ jsx5(HelpHeadsetIcon, {}), ...props2, children: t("help.buttonText") })
      }
    ) })
  ] });
}

// src/internal/components/totp-panel/totp-panel-footer.tsx
import { Fragment as Fragment4, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var TotpPanelFooter = ({
  onContinue,
  action,
  actionType
}) => {
  const snackbar = useSnackbar4();
  const showSnackBar = useCallback3(
    (message, status) => {
      snackbar({
        message,
        status,
        position: "bottom-left",
        duration: 5e3
      });
    },
    [snackbar]
  );
  const {
    totp: {
      codes: { loading, value: OtpCodes },
      fetchCodes,
      isTimeUp,
      isCodeExpired
    }
  } = useAuthContext4();
  const { sidePanel } = useLayoutContext();
  const { t } = useT5("auth");
  const isDisabled = useMemo(() => {
    if (isTimeUp || !OtpCodes.code || isEmpty(OtpCodes.code) || OtpCodes.code.length < 5 || isCodeExpired || loading)
      return true;
    return false;
  }, [OtpCodes.code, isTimeUp, loading, isCodeExpired]);
  return /* @__PURE__ */ jsxs5(Fragment4, { children: [
    /* @__PURE__ */ jsx6(
      Button3,
      {
        variant: "secondary",
        isDisabled: loading,
        isLoading: loading,
        onClick: () => {
          fetchCodes(action, actionType).then(({ code, token }) => {
            if (!!code && !!token) {
              onContinue(OtpCodes);
            } else if (!code && !!token) {
              showSnackBar(t("totp.generateCode.success"), "success");
            }
          }).catch((error) => {
            if (error.response.status === 401) {
              sidePanel.onOpen(TOTPRiskPanel, 0);
            } else {
              showSnackBar(
                t("totp.generateCode.error", { ns: "auth" }),
                "error"
              );
            }
          });
        },
        flex: 1,
        children: t("totp.sidepanel.button.resendCode")
      }
    ),
    /* @__PURE__ */ jsx6(
      Button3,
      {
        isLoading: loading,
        isDisabled,
        onClick: () => {
          onContinue(OtpCodes);
        },
        type: "button",
        flex: 1,
        children: t("totp.sidepanel.button.continue")
      }
    )
  ] });
};

export {
  TotpPanelFooter,
  TOTPPanel,
  EditPhoneForm,
  two_factor_disabled_panel_v3_default,
  user_profile_panel_default,
  Header2 as Header,
  HeaderWider2 as HeaderWider
};
